export function formatCurrency(val: unknown) {
  return (Number(val) || 0).toLocaleString('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    currencyDisplay: 'symbol'
  }).replace('₽', '')
}
